import { Link } from 'react-router-dom';
import Seo from '@/components/base/Seo';
import { categoryList, newsList } from '@/mocks/news';

const circleList = categoryList.filter((cat) => cat.id !== 'all');

export default function Topics() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '黑料爆料专题分类',
      description: '按娱乐圈、网红圈、综艺、影视、音乐、电竞、情感与网络热点九个圈子浏览最新爆料动态。',
      url: 'https://utuyxa.cn/topics',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://utuyxa.cn/' },
        {
          '@type': 'ListItem',
          position: 2,
          name: '专题分类',
          item: 'https://utuyxa.cn/topics',
        },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="专题分类 | 黑料爆料九大圈子实时更新"
        description="黑料爆料专题分类页，按娱乐圈、网红圈、综艺瓜、影视剧、音乐现场、电竞圈、情感八卦与网络热点九个圈子分类浏览最新动态，快速找到你关心的方向。"
        keywords="黑料爆料专题,黑料爆料分类,娱乐圈爆料,网红圈动态,黑料爆料实时更新"
        path="/topics"
        jsonLd={jsonLd}
      />

      <section className="w-full border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
          <nav aria-label="面包屑" className="flex items-center gap-2 text-xs text-foreground-500">
            <Link to="/" className="transition-colors hover:text-primary-400">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-700">专题分类</span>
          </nav>
          <h1 className="mt-5 font-heading text-4xl text-foreground-950 md:text-5xl">
            九大圈子，一次看全
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            每个圈子下都汇集了近期讨论度最高的内容。点击卡片右上角的「进入圈子」，
            即可回到首页并按该圈子筛选实时情报流。
          </p>
        </div>
      </section>

      <section className="w-full">
        <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
            {circleList.map((cat) => {
              const items = newsList.filter((item) => item.categoryId === cat.id).slice(0, 2);
              return (
                <article
                  key={cat.id}
                  className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-400/60"
                >
                  <div className="flex items-start justify-between gap-4">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-200 text-accent-400">
                      <i className={`${cat.icon} text-2xl`} />
                    </span>
                    <Link
                      to={`/?cat=${cat.id}#feed`}
                      className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-label text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-400"
                    >
                      进入圈子
                      <i className="ri-arrow-right-s-line" />
                    </Link>
                  </div>
                  <h2 className="mt-5 font-heading text-2xl text-foreground-950">{cat.name}</h2>
                  <p className="mt-2 text-sm text-foreground-600">{cat.desc}</p>

                  <ul className="mt-5 flex flex-1 flex-col gap-3 border-t border-background-200 pt-5">
                    {items.length > 0 ? (
                      items.map((item) => (
                        <li key={item.id}>
                          <Link
                            to={`/article/${item.id}`}
                            className="group flex items-start gap-2 text-sm text-foreground-700 transition-colors hover:text-foreground-950"
                          >
                            <i className="ri-links-line mt-1 text-foreground-500 transition-colors group-hover:text-primary-400" />
                            <span className="line-clamp-2">{item.title}</span>
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li className="text-sm text-foreground-500">该圈子内容整理中，稍后更新。</li>
                    )}
                  </ul>

                  <p className="mt-5 text-xs text-foreground-500">
                    共 {newsList.filter((item) => item.categoryId === cat.id).length} 条内容
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}